import { normalizeWidgetTheme, APIURL, cancelSelectEvent, changeSymbolForWidget, getCSSStyles, getSymbolDropdown, getTraderSMCardHTML, getWidgetDataURI, apiGet, toggleWidgetTheme, getEChartsTooltipTheme, updateSelectedSymbolInDropdown, isHeaderPinned, getHeaderPinStateClass, getHeaderPinButtonHTML, setupHeaderPin } from './../../helpers';
import { FinancialConfig, WidgetEvent, WidgetEventHandler, WidgetEventType } from './../../types';

export class TraderverseRatingActionMomentumTracker {
    private container: HTMLElement;
    private config: FinancialConfig;
    private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
    private updateInterval: number | null = null;
    private shadowRoot: ShadowRoot;
    private currentData: any = null;
    private currentColors: any = { upgrade: '#4CAF50', hold: '#FF9800', downgrade: '#F44336' };
    private currentChart: any;
    private hasDataLoaded: boolean = false;
    private widgetResizeObserver: ResizeObserver | null = null;
    constructor(config: FinancialConfig) {
        this.config = { ...this.getDefaultConfig(), ...config };
        this.config.theme = normalizeWidgetTheme(this.config.theme);
        this.container = this.resolveContainer(config.container);

        if ((this.container as any).shadowRoot) {
            this.shadowRoot = (this.container as any).shadowRoot;
        } else {
            this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
        }
        this.init();

        this.widgetResizeObserver = new ResizeObserver(() => {
            this.updateDisplay();
        });
        setTimeout(() => {
            const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
            if (widget) this.widgetResizeObserver?.observe(widget);
        }, 0);
    }

    private getDefaultConfig(): Partial<FinancialConfig> {
        const symbols = this.fetchSymbols();
        return {
      headerPinned: true,
            symbol: symbols[0].value,
            theme: 'default-dark',
            width: '100%',
            height: '400px',
            autosize: true,
        };
    }

    private fetchSymbols(): Array<{ value: string; label: string }> {
        return [
            { label: 'AAPL', value: 'AAPL' }, { label: 'MSFT', value: 'MSFT' },
            { label: 'GOOGL', value: 'GOOGL' }, { label: 'AMZN', value: 'AMZN' },
            { label: 'NVDA', value: 'NVDA' }, { label: 'META', value: 'META' },
            { label: 'TSLA', value: 'TSLA' }, { label: 'AVGO', value: 'AVGO' },
            { label: 'PEP', value: 'PEP' }, { label: 'COST', value: 'COST' }
        ];
    }

    private resolveContainer(container: string | HTMLElement): HTMLElement {
        if (typeof container === 'string') {
            const el = document.getElementById(container) || document.querySelector(container);
            if (!el) throw new Error(`Container not found: ${container}`);
            return el as HTMLElement;
        }
        return container;
    }

    private async init(): Promise<void> {
        this.createWidget();
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        if (widget) widget.classList.add('loading');
        await this.injectChartLibrary();
        this.attachStyles();
        await this.setupChart(this.config.symbol!);
        if (widget) widget.classList.remove('loading');
        this.emit('ready', {});
        cancelSelectEvent(this.shadowRoot);
        this.config.onReady?.();
    }

    private createWidget(): void {
        let themeClass = 'defaultDarkMode';
      let dataTheme = 'default-dark';
      
      if (this.config.theme === 'white') {
        themeClass = 'whiteMode';
        dataTheme = 'white';
      } else if (this.config.theme === 'black') {
        themeClass = 'blackMode';
        dataTheme = 'black';
      } else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}
        const widgetHtml = `
     <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width  };height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-theme="${dataTheme}">
        <div class="headTop">
            <h4 class="title market">${this.getTitleIconSvg()} Rating Action Momentum Tracker </h4>
            <div class="actionCol">${getHeaderPinButtonHTML(this.config)} <div class="item">
                <button class="filters-toggle" type="button"> <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.1794 0.950592H1.72077C1.57285 0.950469 1.42802 0.991908 1.30363 1.06995C1.17925 1.14799 1.08058 1.25932 1.01944 1.39061C0.958302 1.5219 0.937286 1.66759 0.958909 1.81023C0.980533 1.95286 1.04388 2.0864 1.14136 2.19484L5.22108 6.73834C5.34378 6.8752 5.41132 7.05084 5.41114 7.23259V10.8881C5.41114 10.9463 5.42504 11.0037 5.45175 11.0558C5.47846 11.1079 5.51725 11.1532 5.56503 11.1881L7.87343 12.8756C7.93059 12.9174 7.99856 12.9428 8.06972 12.9491C8.14088 12.9553 8.21242 12.9421 8.27633 12.911C8.34023 12.8799 8.39398 12.832 8.43154 12.7727C8.46911 12.7135 8.489 12.6452 8.489 12.5756V7.23259C8.48882 7.05084 8.55636 6.8752 8.67906 6.73834L12.7588 2.19409C13.1943 1.70959 12.8403 0.950592 12.1794 0.950592Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/> </svg> </button>
              </div> </div>
        </div>
        <div class="inBody">
            <div class="optionsRow">
                ${this.config.hideSymbol ? '<div class="item dropStyle01"></div>' : `<div class="item dropStyle01">
                    <div class="trader-sm-card" id="selected-symbol"> ${getTraderSMCardHTML(this.config.stock ?? { symbol: this.config.symbol || '', type: "stock", name: "" })} </div>
                    <span id="symbol-dropdown-placeholder"></span>
                </div>`}
                <span></span>

                <div class="filtersBox sideBar hidden">
                    <div class="item">
                        <label for="p_time_period">Time period</label>
                        <select id="p_time_period" title="Select time period">
                        <option value="6month" selected>6 Month</option>
                        <option value="3month">3 Month</option>
                        <option value="1month">1 Month</option>
                        <option value="1year">1 Year</option>
                        </select>
                    </div>
                    <div class="item">
                        <label for="p_group_by">Group by</label>
                        <select id="p_group_by" title="Grouping interval">
                        <option value="week" selected>Week</option>
                        <option value="day">Day</option>
                        <option value="month">Month</option>
                        </select>
                    </div>
                    <div class="item">
                        <div class="checkBoxField">
                            <input id="p_show_net_change" type="checkbox" />
                            <label for="p_show_net_change">Show net change <i>✓</i></label>
                        </div>
                    </div>
                    <div class="item">
                        <label for="p_action_filter">Action</label>
                        <select id="p_action_filter" title="Action filter">
                        <option value="all" selected>All</option>
                        <option value="upgrade">Upgrade</option>
                        <option value="downgrade">Downgrade</option>
                        </select>
                    </div>
                    <div class="item">
                        <label for="p_firm_filter">Firms</label>
                        <input id="p_firm_filter" type="text" placeholder="Type firms, comma-separated" title="Enter firm names separated by comma" />
                    </div>
                </div>
            </div>
            <div class="chartDv" id="aiAnalysisScoreDistribution">
                <div id="chartContainer" class="chart"></div>
            </div>
        </div>
        </div>
        `;
        this.shadowRoot.innerHTML = widgetHtml;
    setupHeaderPin(this.shadowRoot, this.config);
        const changeHandler = () => { try { this.setupChart(this.config.symbol!); } catch (e) { console.error(e); } };

        const timeEl = this.shadowRoot.querySelector('#p_time_period') as HTMLSelectElement | null;
        const groupEl = this.shadowRoot.querySelector('#p_group_by') as HTMLSelectElement | null;
        const showNetEl = this.shadowRoot.querySelector('#p_show_net_change') as HTMLInputElement | null;
        const actionEl = this.shadowRoot.querySelector('#p_action_filter') as HTMLSelectElement | null;
        const firmEl = this.shadowRoot.querySelector('#p_firm_filter') as HTMLInputElement | null;

        [timeEl, groupEl, actionEl].forEach(el => { if (el) el.addEventListener('change', changeHandler); });
        if (showNetEl) showNetEl.addEventListener('change', changeHandler);
        if (firmEl) firmEl.addEventListener('change', changeHandler);
        if (this.config.isSymbolSelectable && !this.config.hideSymbol) {
            const dropdown = getSymbolDropdown((data: any) => this.onSelectChange(data));
            const placeholder = this.shadowRoot.getElementById('symbol-dropdown-placeholder');
            if (placeholder && dropdown) {
                placeholder.replaceWith(dropdown);
            }
        }
        const filtersToggleBtn = this.shadowRoot.querySelector('.filters-toggle') as HTMLButtonElement | null;
        const filtersBoxEl = this.shadowRoot.querySelector('.filtersBox') as HTMLElement | null;
        if (filtersToggleBtn && filtersBoxEl) {
            filtersToggleBtn.addEventListener('click', (ev: Event) => {
                ev.stopPropagation();
                filtersBoxEl.classList.toggle('hidden');
            });
        }
    }

    onSelectChange(stock: any) {
        this.changeSymbol(stock.symbol, stock);
    }

    private async attachStyles(): Promise<void> {
        try {
            const styleEl = await getCSSStyles();
            this.shadowRoot.appendChild(styleEl);
        } catch (err) {
            console.error('Failed to load CSS file:', err);
        }
    }


    private async injectChartLibrary(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            if ((window as any).echarts) return resolve(true);
            if (this.shadowRoot.querySelector('script[data-chart-lib]')) {
                const script = this.shadowRoot.querySelector('script[data-chart-lib]') as HTMLScriptElement;
                script.onload = () => resolve(true);
            } else {
                const script = document.createElement('script');
                script.src = 'https://cdn.jsdelivr.net/npm/echarts@5/dist/echarts.min.js';
                script.async = true;
                script.setAttribute('data-chart-lib', 'true');
                this.shadowRoot.appendChild(script);
                script.onload = () => resolve(true);
            }
        });
    }

    private async setupChart(symbol: string): Promise<void> {
        try {
            const timeEl = this.shadowRoot.querySelector('#p_time_period') as HTMLSelectElement | null;
            const groupEl = this.shadowRoot.querySelector('#p_group_by') as HTMLSelectElement | null;
            const showNetEl = this.shadowRoot.querySelector('#p_show_net_change') as HTMLInputElement | null;
            const actionEl = this.shadowRoot.querySelector('#p_action_filter') as HTMLSelectElement | null;
            const firmEl = this.shadowRoot.querySelector('#p_firm_filter') as HTMLInputElement | null;

            const params = new URLSearchParams();
            params.append('p_symbol', symbol || (this.config.symbol || ''));
            params.append('p_time_period', (timeEl && timeEl.value) ? timeEl.value : '6month');
            params.append('p_group_by', (groupEl && groupEl.value) ? groupEl.value : 'week');
            params.append('p_show_net_change', (showNetEl && showNetEl.checked) ? 'true' : 'false');
            params.append('p_action_filter', (actionEl && actionEl.value) ? actionEl.value : 'all');
            if (firmEl) {
                const raw = (firmEl.value || '').toString();
                const firms = raw.split(',').map(s => s.trim()).filter(Boolean);
                if (firms.length > 0) {
                    firms.forEach(f => params.append('p_firm_filter', f));
                }
            }

            const url = `${APIURL}/v1/discover/rating-action-momentum?${params.toString()}`;
            const res = await apiGet({
                url,
                method: "GET",
            });

            if (!res.ok) throw new Error(`API error: ${res.status}`);
            const json = await res.json();

            // API returns an object with `data` (array) and `colors` map
            this.currentData = json?.data?.data || [];
            this.currentColors = json?.data?.colors || this.currentColors;
            this.hasDataLoaded = true;
            this.updateDisplay();
            this.emit('dataUpdate', this.currentData);
        } catch (err) {
            console.error("Error fetching chart data:", err);
        }
    }


    private updateDisplay(): void {
            const widget = this.shadowRoot.querySelector('.chart') as HTMLElement;

    if (this.currentData && this.hasDataLoaded) {
        widget?.setAttribute('data-testing-id', 'rating-action-momentum-tracker');
    } else {
        widget?.removeAttribute('data-testing-id');
    }

        if (!this.currentData || !(window as any).echarts) {
            setTimeout(() => this.updateDisplay(), 100);
            return;
        }
        this.renderSentimentChart();
    }


    private renderSentimentChart(): void {
        const container = this.shadowRoot.querySelector('#aiAnalysisScoreDistribution');
        if (!container) return;

        this.drawSentimentChart();
    }

 private weekToDate(year: number, week: number): string {
    const date = new Date(year, 0, 1 + (week - 1) * 7);
    const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    };
    return date.toLocaleDateString('en-US', options);
}



    private drawSentimentChart(): void {
        const echarts = (window as any).echarts;
        const container = this.shadowRoot.querySelector('#chartContainer') as HTMLDivElement;
        const instance = echarts.getInstanceByDom(container);
        if (instance) echarts.dispose(instance);

        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;

        if (!this.currentData || this.currentData.length === 0) {
            container.innerHTML = `<div class="noData"><p>No rating-action data available.</p></div>`;
            return;
        }
  const xAxisData = this.currentData.map((d: any) => {
    const match = d.time_period.match(/(\d{4})-w(\d{1,2})/i);
    if (!match) return d.time_period;

    return this.weekToDate(+match[1], +match[2]);
});


        const upgradeSeries = this.currentData.map((d: any) => d.upgrade_count || 0);
        const holdSeries = this.currentData.map((d: any) => d.hold_count || 0);
        const downgradeSeries = this.currentData.map((d: any) => d.downgrade_count || 0);

        // const isBlack = this.config.theme === 'black';
        const widgetBox = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        const textColor = getComputedStyle(widgetBox).getPropertyValue('--charts-text-color');
        const axisLineColor = getComputedStyle(widgetBox).getPropertyValue('--charts-axis-color');
        const splitLineColor = getComputedStyle(widgetBox).getPropertyValue('--charts-split-line-color');
        //widgetBox ? getComputedStyle(widgetBox).getPropertyValue('--text-white').trim()

        const option = {
            backgroundColor: 'transparent',
            animation: true,

            legend: {
                top: 0,
                data: ['Upgrades', 'Holds', 'Downgrades'],
                textStyle: { color: textColor }
            },

            tooltip: {
                trigger: 'axis',
                axisPointer: { type: 'shadow' },
                ...getEChartsTooltipTheme(widgetBox),
                formatter: (params: any) => {
                    const name = params[0]?.axisValue || '';
                    let out = `<strong>${name}</strong><br/>`;
                    params.forEach((p: any) => {
                        out += `${p.marker} ${p.seriesName}: ${p.data}<br/>`;
                    });
                    return out;
                }
            },

            grid: { left: 0, right: 0, top: 30, bottom: 0, containLabel: true },

            xAxis: [{
                type: 'category',
                data: xAxisData,
                axisLine: { lineStyle: { color: axisLineColor } },
                axisLabel: { color: textColor, fontSize: 12 }
            }],

            yAxis: [{
                type: 'value',
                axisLine: { lineStyle: { color: axisLineColor } },
                splitLine: { lineStyle: { color: splitLineColor, type: 'dashed' } },
                axisLabel: { color: textColor, fontSize: 12 }
            }],

            color: [
                this.currentColors.upgrade || '#4CAF50',
                this.currentColors.hold || '#FF9800',
                this.currentColors.downgrade || '#F44336'
            ],
            series: [
                {
                    name: 'Upgrades',
                    type: 'bar',
                    stack: 'total',
                    barMaxWidth: 50,
                    data: upgradeSeries,
                    itemStyle: {
                        borderRadius: [4, 4, 0, 0] // top corners won't show if it's not the top bar
                    }
                },
                {
                    name: 'Holds',
                    type: 'bar',
                    stack: 'total',
                    data: holdSeries,
                    itemStyle: {
                        borderRadius: [4, 4, 0, 0] // top corners won't show if it's not the top bar
                    }
                },
                {
                    name: 'Downgrades',
                    type: 'bar',
                    stack: 'total',
                    data: downgradeSeries,
                    itemStyle: {
                        borderRadius: [4, 4, 0, 0] // top corners won't show if it's not the top bar
                    }
                }
            ]
        };

        const chart = echarts.init(container, null, {
            // backgroundColor: getComputedStyle(widget).getPropertyValue('--bg-primary').trim()
        });

        chart.setOption(option);
        this.currentChart = chart;
    }




    private changeSymbol(stockId: string, stock: any = null): void {
        changeSymbolForWidget(this.shadowRoot, this.config, stock, stockId, (stockId: any) => this.setupChart(stockId), (type: any, data: any) => this.emit(type, data));
    }

    public on(type: WidgetEventType, handler: WidgetEventHandler): void {
        if (!this.eventHandlers.has(type)) this.eventHandlers.set(type, []);
        this.eventHandlers.get(type)!.push(handler);
    }
    public off(type: WidgetEventType, handler: WidgetEventHandler): void {
        const list = this.eventHandlers.get(type);
        if (list) this.eventHandlers.set(type, list.filter(h => h !== handler));
    }
    public setSymbol(symbol: string): void {
        this.changeSymbol(symbol);
        const dropdown = this.shadowRoot.querySelector('.symbol-dropdown') as HTMLSelectElement;
        if (dropdown) dropdown.value = symbol;
    }
    public async getWidgetImage(): Promise<string> {
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        return await getWidgetDataURI(widget);
    }
  
    public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
      if (!this.shadowRoot) return;
    
      this.config.theme = toggleWidgetTheme(
        this.shadowRoot,
        theme
      ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';
    
      this.updateDisplay();
    }
    public destroy(): void {
        if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
        if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
        this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
    }
    private emit(type: WidgetEventType, data: any): void {
        const handlers = this.eventHandlers.get(type);
        if (handlers) { const evt: WidgetEvent = { type, data }; handlers.forEach(h => h(evt)); }
    }
    private getTitleIconSvg(): string {
      return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z" fill="currentColor"/> <path d="M9.16252 19.05C8.96252 19.05 8.76252 18.9875 8.58752 18.85C8.17502 18.5375 8.10002 17.95 8.41252 17.5375L11.3875 13.675C11.75 13.2125 12.2625 12.9125 12.85 12.8375C13.425 12.7625 14.0125 12.925 14.475 13.2875L16.7625 15.0875C16.85 15.1625 16.9375 15.1625 17 15.15C17.05 15.15 17.1375 15.125 17.2125 15.025L20.1 11.3C20.4125 10.8875 21.0125 10.8125 21.4125 11.1375C21.825 11.45 21.9 12.0375 21.575 12.45L18.6875 16.175C18.325 16.6375 17.8125 16.9375 17.225 17C16.6375 17.075 16.0625 16.9125 15.6 16.55L13.3125 14.75C13.225 14.675 13.125 14.675 13.075 14.6875C13.025 14.6875 12.9375 14.7125 12.8625 14.8125L9.88752 18.675C9.72502 18.925 9.45002 19.05 9.16252 19.05Z" fill="currentColor"/> </svg>`;
    }

}

declare global { interface Window { TraderverseRatingActionMomentumTracker: typeof TraderverseRatingActionMomentumTracker; } }
if (typeof window !== 'undefined') { window.TraderverseRatingActionMomentumTracker = TraderverseRatingActionMomentumTracker; }
